import { render, staticRenderFns } from "./CanvasEditor.vue?vue&type=template&id=687cca62&scoped=true&"
import script from "./CanvasEditor.vue?vue&type=script&lang=js&"
export * from "./CanvasEditor.vue?vue&type=script&lang=js&"
import style0 from "./CanvasEditor.vue?vue&type=style&index=0&id=687cca62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687cca62",
  null
  
)

export default component.exports